<mic-spinner-overlay ariaLabel="loading" color="primary" [loading]="isLoading">

  <h1>{{ 'sites.siteSettings.stockSettings.title' | translate }}</h1>
  <p>{{ 'sites.siteSettings.stockSettings.description' | translate }}</p>

  <div class="site-settings-flex-wrapper">
    <div class="stock-settings-main-block">
      <div>
        <tkc-modification-buttons
          [isModificationsPending]="sizeSettingsForm.dirty"
          [saveModifications]="saveModifications.bind(this)"
          [resetModifications]="resetModifications.bind(this)">
        </tkc-modification-buttons>
      </div>
      <table mat-table [dataSource]="sizeSettingsControls">
        <ng-container matColumnDef="size">
          <th mat-header-cell *matHeaderCellDef>
            <span class="tab-header-title">{{ 'sites.siteSettings.table.size' | translate }}</span>
          </th>
          <td mat-cell *matCellDef="let group">
            {{ group.get('size').value }}
          </td>
        </ng-container>
        <ng-container matColumnDef="frozenPeriod">
          <th mat-header-cell *matHeaderCellDef class="stock-settings-tab-header">
            <span class="tab-header-title">{{ 'sites.siteSettings.table.frozenPeriod' | translate }}</span>
            <span class="tab-header-subtitle">{{ 'sites.siteSettings.table.month' | translate }}</span>
          </th>

          <td mat-cell *matCellDef="let group">
            @if (group.get(IS_DATA_LINE).value) {
              <input matInput
                     type="text"
                     maxlength="2"
                     class="tkc-input"
                     nxNoScroll
                     [mask]="digitMask"
                     [patterns]="digitPatterns"
                     [dropSpecialCharacters]="true"
                     [ngClass]="{'ng-invalid': group.get(COL_FROZEN_PERIOD).invalid}"
                     [formControl]="group.get(COL_FROZEN_PERIOD)"
                     (change)="onFrozenPeriodChange(group.get(COL_FROZEN_PERIOD))"
                     required />
            }
            @else {
              <input matInput
                     type="text"
                     maxlength="2"
                     class="tkc-input"
                     nxNoScroll
                     [mask]="digitMask"
                     [patterns]="digitPatterns"
                     [dropSpecialCharacters]="true"
                     [formControl]="group.get(COL_FROZEN_PERIOD)"
                     (keydown.enter)="updateColumns(COL_FROZEN_PERIOD, $event)"
                     (change)="updateColumns(COL_FROZEN_PERIOD, $event)"/>
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="coverageMin">
          <th mat-header-cell *matHeaderCellDef class="stock-settings-tab-header">
            <span class="tab-header-title">{{ 'sites.siteSettings.table.coverageMin' | translate }}</span>
            <span class="tab-header-subtitle">{{ 'sites.siteSettings.table.month' | translate }}</span>
          </th>
          <td mat-cell *matCellDef="let group">
            @if (group.get(IS_DATA_LINE).value) {
              <input matInput type="text"
                     maxlength="2"
                     class="tkc-input"
                     nxNoScroll
                     [mask]="digitMask"
                     [patterns]="digitPatterns"
                     [dropSpecialCharacters]="true"
                     [ngClass]="{'ng-invalid': group.get(COL_COVERAGE_MIN).invalid}"
                     [formControl]="group.get(COL_COVERAGE_MIN)"
                     (change)="onCoverageMinChange(group)"
                     required
              />
            }
            @else {
              <input matInput
                     type="text"
                     maxlength="2"
                     class="tkc-input"
                     nxNoScroll
                     [mask]="digitMask"
                     [patterns]="digitPatterns"
                     [dropSpecialCharacters]="true"
                     [formControl]="group.get(COL_COVERAGE_MIN)"
                     (keydown.enter)="updateColumns(COL_COVERAGE_MIN, $event)"
                     (change)="updateColumns(COL_COVERAGE_MIN, $event)"/>
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="coverageMax">
          <th mat-header-cell *matHeaderCellDef class="stock-settings-tab-header">
            <span class="tab-header-title">{{ 'sites.siteSettings.table.coverageMax' | translate }}</span>
            <span class="tab-header-subtitle">{{ 'sites.siteSettings.table.month' | translate }}</span>
          </th>
          <td mat-cell *matCellDef="let group">
            @if (group.get(IS_DATA_LINE).value) {
              <input matInput
                     type="text"
                     maxlength="3"
                     class="tkc-input"
                     nxNoScroll
                     [mask]="digitMask"
                     [patterns]="digitPatterns"
                     [dropSpecialCharacters]="true"
                     [ngClass]="{'ng-invalid': group.get(COL_COVERAGE_MAX).invalid}"
                     [formControl]="group.get(COL_COVERAGE_MAX)"
                     (change)="onCoverageMaxChange(group)"
                     required />
            }
            @else {
              <input matInput
                     type="text"
                     maxlength="2"
                     class="tkc-input"
                     nxNoScroll
                     [mask]="digitMask"
                     [patterns]="digitPatterns"
                     [dropSpecialCharacters]="true"
                     [formControl]="group.get(COL_COVERAGE_MAX)"
                     (keydown.enter)="updateColumns(COL_COVERAGE_MAX, $event)"
                     (change)="updateColumns(COL_COVERAGE_MAX, $event)"/>
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="quantityMin">
          <th mat-header-cell *matHeaderCellDef class="stock-settings-tab-header">
            <span class="tab-header-title">{{ 'sites.siteSettings.table.quantityMin' | translate }}</span>
            <span class="tab-header-subtitle">{{ 'sites.siteSettings.table.tire' | translate }}</span>
          </th>
          <td mat-cell *matCellDef="let group">
            @if (group.get(IS_DATA_LINE).value) {
              <input matInput
                     type="text"
                     maxlength="4"
                     class="tkc-input"
                     nxNoScroll
                     [mask]="digitMask"
                     [patterns]="digitPatterns"
                     [dropSpecialCharacters]="true"
                     [formControl]="group.get(COL_QTY_MIN)"
                     (change)="onQtyMinChange(group.get(COL_QTY_MIN))"
                     required />
            } @else {
              <input matInput
                     type="text"
                     maxlength="4"
                     class="tkc-input"
                     nxNoScroll
                     [ngClass]="{'ng-invalid': group.get(COL_QTY_MIN).invalid}"
                     [mask]="digitMask"
                     [patterns]="digitPatterns"
                     [dropSpecialCharacters]="true"
                     [formControl]="group.get(COL_QTY_MIN)"
                     (keydown.enter)="updateColumns(COL_QTY_MIN, $event)"
                     (change)="updateColumns(COL_QTY_MIN, $event)"/>
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="orderMultiple">
          <th mat-header-cell *matHeaderCellDef class="stock-settings-tab-header">
            <span class="tab-header-title">{{ 'sites.siteSettings.table.orderMultiple' | translate }}</span>
            <span class="tab-header-subtitle">{{ 'sites.siteSettings.table.tire' | translate }}</span>
          </th>
          <td mat-cell *matCellDef="let group">
            @if (group.get(IS_DATA_LINE).value) {
              <input matInput
                     type="text"
                     maxlength="4"
                     class="tkc-input"
                     nxNoScroll
                     [mask]="digitMask"
                     [patterns]="digitPatterns"
                     [dropSpecialCharacters]="true"
                     [formControl]="group.get(COL_ORDER_MULTIPLE)"
                     (change)="onOrderMultipleChange(group.get(COL_ORDER_MULTIPLE))"
                     required />
            } @else {
              <input matInput
                     type="text"
                     maxlength="4"
                     class="tkc-input"
                     nxNoScroll
                     [mask]="digitMask"
                     [patterns]="digitPatterns"
                     [dropSpecialCharacters]="true"
                     [formControl]="group.get(COL_ORDER_MULTIPLE)"
                     (keydown.enter)="updateColumns(COL_ORDER_MULTIPLE, $event)"
                     (change)="updateColumns(COL_ORDER_MULTIPLE, $event)"/>
            }

          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="['size', 'frozenPeriod', 'coverageMin', 'coverageMax', 'quantityMin', 'orderMultiple']"></tr>
        <tr mat-row *matRowDef="let group; columns: ['size', 'frozenPeriod', 'coverageMin', 'coverageMax', 'quantityMin', 'orderMultiple'];"
            [ngClass]="{ 'update-all-value-row': !group.get(IS_DATA_LINE).value }"></tr>
      </table>
      @if (!isLoading && sizeSettingsControls.length <= 1) {
        <tkc-no-data></tkc-no-data>
      }
    </div>
    <div class="stock-settings-second-block">
      <div class="default-block seasonality-block">
        <h3>Seasonality</h3>
        <span
          class="seasonality-infos"
        >
        {{ 'sites.siteSettings.seasonality.info' | translate }}
      </span>
        <button [routerLink]="['/sites/seasonality']" class="show-seasonality-btn" mat-flat-button>{{ 'sites.siteSettings.seasonality.showSeasonalityBtn' | translate }}</button>
      </div>
    </div>
  </div>
</mic-spinner-overlay>
